export const BLOCK_SIZE = 64
export const ACTIVE_COLOR = '#2185C5'
export const GROUND_COLOR = '#FFF6E5'
export const PATH_COLOR = '#dfd4bf'
export const WALL_COLOR = '#FF7F66'
export const GOAL_COLOR = '#00FF88'
export const START_COLOR = '#00DEFF'
export const TOWER_COLOR = '#ff0099'
export const ENEMY_COLOR = '#ff0000'

function heuristic(position0, position1) {
  let d1 = Math.abs(position1.x - position0.x)
  let d2 = Math.abs(position1.y - position0.y)

  return d1 + d2
}

export const findPath = (grid) => {
  let openSet = []
  let closedSet = []
  let path = []

  let start
  let end
  grid.forEach(row => {
    row.forEach(object => {
      if(object.type === 'START') {
        start = object
      }

      if(object.type === 'GOAL') {
        end = object
      }
    })
  })

  openSet.push(start)

  while (openSet.length > 0) {
    //assumption lowest index is the first one to begin with
    let lowestIndex = 0
    for (let i = 0; i < openSet.length; i++) {
      if (openSet[i].f < openSet[lowestIndex].f) {
        lowestIndex = i
      }
    }
    let current = openSet[lowestIndex]

    if (current === end) {
      let temp = current
      path.push(temp)
      while (temp.parent) {
        path.push(temp.parent)
        temp = temp.parent
      }

      // return the traced path
      return path.reverse()
    }

    //remove current from openSet
    openSet.splice(lowestIndex, 1)
    //add current to closedSet
    closedSet.push(current)

    const neighbors = Object.values(current.neighbors)
      .filter(i => i)
      .filter(neighbor => neighbor.type === 'GROUND' || neighbor.type === 'START' || neighbor.type === 'GOAL')

    for (let i = 0; i < neighbors.length; i++) {
      let neighbor = neighbors[i]

      if (!closedSet.includes(neighbor)) {
        let possibleG = current.g + 1

        if (!openSet.includes(neighbor)) {
          openSet.push(neighbor)
        } else if (possibleG >= neighbor.g) {
          continue
        }

        neighbor.g = possibleG
        neighbor.h = heuristic(neighbor, end)
        neighbor.f = neighbor.g + neighbor.h
        neighbor.parent = current
      }
    }
  }

  console.log('Solution can\'t be found, return []')
  //no solution by default
  return []
}

export const getGridPos = (gridSpot) => ({
  x: Math.floor(gridSpot.x * BLOCK_SIZE),
  y: Math.floor(gridSpot.y * BLOCK_SIZE),
})

export const getGridSpot = (position) => ({
  x: Math.floor(position.x / BLOCK_SIZE),
  y: Math.floor(position.y / BLOCK_SIZE),
})

export const lerp = (end, start, amt) => (1-amt) * start + amt * end

